import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import AppBusyAction from '../../actions/app-busy'
import LazyComponent from '../../components/lazy-component'

export default function withAppBusy(ChildComponent) {

    class WithAppBusyWrapper extends LazyComponent {

        static propTypes = {
            appBusy: PropTypes.object.isRequired,
            dispatch: PropTypes.func.isRequired
        }

        constructor(props) {
            super(props)

            this.loadModules([
                'react-bootstrap'
            ])

            this.setBusy = this.setBusy.bind(this)
            this.unsetBusy = this.unsetBusy.bind(this)
        }

        setBusy(why) {
            this.props.dispatch(AppBusyAction.moreBusy(why))
        }

        unsetBusy(why) {
            this.props.dispatch(AppBusyAction.lessBusy(why))
        }

        renderBusy() {
            const {
                Modal
            } = this.modules['react-bootstrap']

            const { appBusy } = this.props

            if (!appBusy.isBusy) {
                return null
            }

            const causes = appBusy.causes.map((why, i) => {
                const key = [ why, i ].join('--')
                return <div key={key}>{why}</div>
            })

            return (
                <Modal show>
                    <Modal.Header>
                        <Modal.Title>Just a moment...</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {causes}
                    </Modal.Body>
                </Modal>
            )
        }

        lazyRender() {
            const busy = this.renderBusy()

            const childProps = {
                setBusy: this.setBusy,
                unsetBusy: this.unsetBusy,
                renderBusyModal: busy,
                ...this.props
            }

            return (
                <ChildComponent {...childProps} />
            )
        }
    }

    return connect(mapStateToProps)(WithAppBusyWrapper)
}

const mapStateToProps = (state) => {
    const { appBusy } = state

    return {
        appBusy
    }
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-app-busy.js